<template>
  <sp-container class="context-menu__layout-grid-settings" flex direction="column" rowgap="0.5rem">
    <sp-label class="context-menu__sp-label" for="row-gap">Layout Row Gap</sp-label>
    <InputRangeSlider v-model="ui.rowgap" min="0" max="100" step="1" unit="px" value-and-unit-width="6ch" />
  </sp-container>
</template>

<script setup>
import { computed, watch } from "vue";
import { toRemString } from "#ce/utils/css";
import { Context } from "#ce/components/SpLayoutBuilder/constants";
import { useLayoutBuilderStore } from "#ce/components/SpLayoutBuilder/store/layout-builder";
import InputRangeSlider from "#ce/components/SpLayoutBuilder/components/LayoutBuilderContextMenu/InputRangeSlider.ce.vue";

const { settings } = useLayoutBuilderStore({ context: Context.PARENT });

const ui = computed(() => settings.value.ui ?? {});

watch(
  () => ui.value.rowgap,
  (value) => (settings.value.rowgap = toRemString(value)),
);
</script>
